import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Typography, Button, Grid } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import AppBackground from "../components/layout/AppBackground";
import HomeVideoShowcase from "../components/home/HomeVideoShowcase";

export default function PublicHome() {
  const { t, i18n } = useTranslation("home");
  const navigate = useNavigate();
  const langIsEs = i18n.language?.startsWith("es");
  const publicHeroImage = langIsEs
    ? "/assets/home/product-conversation-es.webp"
    : "/assets/home/product-conversation-en.webp";

  return (
    <AppBackground sx={{ pt: { xs: 2.5, md: 4 }, pb: 8 }}>
      <Box sx={{ width: "100%", maxWidth: 1080, mx: "auto" }}>
        <Box
          sx={{
            backgroundColor: "rgba(20, 12, 37, 0.8)",
            borderRadius: 5,
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 18px 50px rgba(0,0,0,0.22)",
            p: { xs: 2.5, md: 4 },
            mb: 3,
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={7}>
              <Typography
                variant="overline"
                sx={{ color: "#C084FC", fontWeight: 700, letterSpacing: 1.1 }}
              >
                {t("public_badge")}
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 900,
                  fontSize: { xs: "2.4rem", md: "3.4rem" },
                  lineHeight: 1.02,
                  mb: 1.5,
                  maxWidth: 580,
                }}
              >
                {t("public_title")}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.72)",
                  fontSize: { xs: "1rem", md: "1.08rem" },
                  maxWidth: 560,
                  mb: 3,
                }}
              >
                {t("public_subtitle")}
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                <Button
                  variant="contained"
                  onClick={() => navigate("/signup")}
                  startIcon={<PlayArrowRoundedIcon />}
                  sx={{
                    borderRadius: 999,
                    px: 3,
                    py: 1.3,
                    fontWeight: 700,
                    textTransform: "none",
                    background: "linear-gradient(to right, #8b5cf6, #a855f7)",
                  }}
                >
                  {t("public_primary_cta")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/login")}
                  startIcon={<LoginRoundedIcon />}
                  sx={{
                    borderRadius: 999,
                    px: 3,
                    py: 1.3,
                    fontWeight: 700,
                    textTransform: "none",
                    color: "#fff",
                    borderColor: "rgba(255,255,255,0.28)",
                  }}
                >
                  {t("public_secondary_cta")}
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box
                component="img"
                src={publicHeroImage}
                alt={t("public_title")}
                sx={{
                  width: "100%",
                  maxWidth: { xs: 340, md: "100%" },
                  height: { xs: 305, md: 430 },
                  objectFit: "cover",
                  objectPosition: "center top",
                  borderRadius: 4,
                  border: "1px solid rgba(255,255,255,0.08)",
                  boxShadow: "0 20px 35px rgba(0,0,0,0.22)",
                  display: "block",
                  mx: "auto",
                }}
              />
            </Grid>
          </Grid>
        </Box>

        <HomeVideoShowcase />
      </Box>
    </AppBackground>
  );
}
